import React from "react";
import { Pie } from "react-chartjs-2";
import { Check, Clock, CornerUpRight, FileText, Gift } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import MainCardOne from "../Cards/MainCardOne";

export const CardCompOne = () => {
  
  return (
    <div>
      <div className="row px-3">
        <div className="col-md-12 col-sm-12 ">
          <div className="row page-heading">
            <div className="col-12 col-md-7 g-0 col-lg-8 mb-xl-0 align-self-center align-items-center">
              <h3 className="fw-bold " style={{ color: '#293990', fontSize: '22px' }}>
                Dashboard
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-3 px-0 " >
        <div className="col-12 col-md-7 col-lg-8 mb-xl-0 align-self-center align-items-center">
          <h6 className="fw-bold px-1 text-dark pt-0 pt-lg-1 pb-1">
            Individual Level
          </h6>
        </div>
        <div className="row  mr-1 mr-lg-0 ">
          <MainCardOne       
            img="./static/assets/img/dashboard/surveyor.png"
            title="Details of Surveyor"
            count="346"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            cardBodyBg="card-body Card-1 p-4 "
            background="#1b306661"
            duration="Since Last Year"
            button="onClick={() => handleChange()}"
          // navigateTo="/Branch-Enquiry-received"
          />
          <MainCardOne
            // icon={<Check />}
            img="./static/assets/img/dashboard/beneficiary.png"
            title="Details of Individual Beneficiaries"
            count="346"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            background="#ff6500b8"
            cardBodyBg="card-body Card-2"
            duration="Since Last Year"
          // navigateTo="/Branch-Enquiry-Approved"
          />
          <MainCardOne
            // icon={<Clock />}
            img="./static/assets/img/dashboard/Plantations.png"
            className=" col-12 col-lg-4 mt-2 mt-lg-0 "
            title="Details of Individual Plantations"
            count="346"
            cardBodyBg="card-body Card-3"
            background="#1b306661"
            duration="Since Last Year"
          // navigateTo="/Branch-Enquiry-pending"
          />
        </div>
      </div>
    </div>
  );
};
